/**
 * Chaves de query padronizadas (Query Key Factory Pattern)
 * Centraliza as keys para facilitar invalidação de cache
 */
const laboratoryKeys = ['laboratory'] as const;
const credentialKeys = [laboratoryKeys[0], 'credentials'] as const;

const userKeys = ['user'] as const;
const fileKeys = ['file'] as const;
const invoiceKeys = ['invoice'] as const;
const receiptKeys = ['receipt'] as const;
const boletoKeys = ['boleto'] as const;

export const queryKeys = {
  laboratory: {
    all: laboratoryKeys,
    lists: () => [...laboratoryKeys, 'list'] as const,
    list: () => [...laboratoryKeys, 'list', 'all'] as const,
    details: () => [...laboratoryKeys, 'detail'] as const,
    detail: (id: string) => [...laboratoryKeys, 'detail', id] as const,
    byCode: (code: string) => [...laboratoryKeys, 'by-code', code] as const,
    credentials: {
      all: credentialKeys,
      lists: () => [...credentialKeys, 'list'] as const,
      list: (labId: string) => [...credentialKeys, 'list', labId] as const,
      byTypes: () => [...credentialKeys, 'by-type'] as const,
      byType: (labId: string, type: string) =>
        [...credentialKeys, 'by-type', labId, type] as const,
    },
  },
  user: {
    all: userKeys,
    lists: () => [...userKeys, 'list'] as const,
    list: () => [...userKeys, 'list', 'all'] as const,
    details: () => [...userKeys, 'detail'] as const,
    detail: (id: string) => [...userKeys, 'detail', id] as const,
    byLaboratory: (labId: string) =>
      [...userKeys, 'by-laboratory', labId] as const,
  },
  file: {
    all: fileKeys,
    lists: () => [...fileKeys, 'list'] as const,
    byCategory: (category: string) =>
      [...fileKeys, 'list', 'by-category', category] as const,
  },
  invoice: {
    all: invoiceKeys,
    lists: () => [...invoiceKeys, 'list'] as const,
    list: () => [...invoiceKeys, 'list', 'all'] as const,
    byCnpj: (cnpj: string) => [...invoiceKeys, 'list', 'by-cnpj', cnpj] as const,
  },
  receipt: {
    all: receiptKeys,
    byLabAndDate: (labCode: string, year: string, month: string) =>
      [...receiptKeys, 'summary', labCode, year, month] as const,
  },
  boleto: {
    all: boletoKeys,
    lists: () => [...boletoKeys, 'list'] as const,
    list: (competence?: string) =>
      [...boletoKeys, 'list', 'all', competence ?? ''] as const,
    titles: (statuses?: string[]) =>
      [...boletoKeys, 'titles', (statuses ?? []).join(',')] as const,
    settings: () => [...boletoKeys, 'settings'] as const,
  },
} as const;

